/**
 * 隐私协议及用户协议弹窗
 */
import { useState } from "react";
import { Modal } from "antd";
import ViewPdf from "@/components/ViewPdf";
import "./index.less";

export const useModal = () => {
  const [isShowContract, setIsShowContract] = useState<boolean>(false);
  const [fileType, setFileType] = useState<"privacy" | "user">("privacy");
  const viewContract = (type: "privacy" | "user") => {
    setFileType(type);
    setIsShowContract(true);
  };

  return {
    isShowContract,
    fileType,
    viewContract,
    setFileType,
    setIsShowContract,
  };
};

export default function PrivacyModel(props: any) {
  //   const { visible, onCancel } = props;
  const { fileType = "privacy", open = false, ...restProps } = props;
  return (
    <Modal
      title={null}
      width={920}
      centered
      maskClosable={false}
      destroyOnClose
      wrapClassName="contract-modal"
      open={open}
      {...restProps}
    >
      <div className="contract-modal-main">
        <div className="contract-title">
          {fileType === "privacy" ? "隐私政策" : "用户协议"}
        </div>
        <div className="contract-container">
          <ViewPdf fileType={fileType}></ViewPdf>
        </div>
      </div>
    </Modal>
  );
}
